import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import Container from './style'

import Checked from '../Checked'

interface Props {
  children: ReactNode[]
  style?: CSSProperties
  className?: string
  id?: string
}

function List({ id, className, style, children }: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      {Array.isArray(children)
        ? children.map((child, index) => (
            <Checked key={`${index}`}>{child}</Checked>
          ))
        : children}
    </Container>
  )
}

List.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element)])
    .isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

List.defaultProps = {
  className: '',
}

export default memo(List)
